import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import CommercialSelectionComponent from "./CommercialSelectionComponent";
import MagellanSelection from "../Selection2/MagellanSelection";
import MagellanShow from "./commercialimagesshow/MagellanShow";
import MagellanShow2 from "./commercialimagesshow/MagellanShow2";

export default function MagellanComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="/Images/CommercialImages/1MagellanRestaurant/DESIGN/DjRenderRevize.jpg"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5">MAGELLAN RESTAURANT</p>
              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>
                  role in project: architectural drawings, 3d visualization,
                  <br />
                  manufacturing of Furnitures, Fixtures and Lighting, Fit-Out,
                  Project Execution
                </span>
                <span>project duration: 5 months</span>
                <span>year of completion: 2020</span>
                <span>project location:Cankaya, Ankara-TURKIYE</span>
              </div>
            </div>
          </div>
        </section>
{/*  */}
        <section className="projects">
          <div className="img">
            <ParallaxImage
              src="/Images/CommercialImages/1MagellanRestaurant/DESIGN/Bahçe4.jpg"
              alt=""
            />
          </div>

          {/* <div className="projects-brief">
              <p
                style={{
                    color:"black",
                    fontSize:"30px"
                }}
              >
              This modern living space and bedroom are designed to inspire with its elegant lines, warm tones, and luxurious finishes, creating an inviting ambiance for both relaxation and entertaining.
              </p>
            </div> */}

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                marginTop: "1000px",
                zIndex: "9999",
              }}
            >
              <ParallaxImage
                src="/Images/CommercialImages/1MagellanRestaurant/DESIGN/SelfiePoint3.jpg"
                alt=""
              />
            </div>
          </div>

          <div className="col projects-list">
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                sophisticated
                <br />
                blend
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                of
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                modern
                <br />
                design
              </h1>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage src="../../Images/Untitled.png" alt="" />
          </div>

          <div className="projects-brief">
            <p
              style={{
                color: "#dbccc0",

                paddingLeft: "350px",
                width: "800px",
                fontSize: "35px",
                textAlign: "left",
              }}
            >
              The backlit bar, adorned with bold branding and crafted from
              premium materials like marble and metal finishes, serves as a
              striking centerpiece. From conceptual design to 3D visualization,
              we managed every step of the process, collaborating with top
              suppliers and overseeing installation to deliver a seamless,
              high-end dining experience.
            </p>
          </div>

          <div className="col projects-cover">
            <div className="img" style={{}}>
              <ParallaxImage
                src="/Images/CommercialImages/1MagellanRestaurant/DESIGN/SelfiePoint3.jpg"
                alt=""
              />
            </div>
          </div>

          <div
            className="col projects-list"
            style={{
              opacity: "0",
            }}
          >
            <div className="project">
              <h1>A Perfect Blend</h1>
            </div>
            <div className="project">
              <h1>Blend of Style and Comfort</h1>
            </div>
            <div className="project">
              <h1>Comfort</h1>
            </div>
            <div className="project">
              <h1>2024</h1>
            </div>
          </div>
        </section>

        <section className="about">
          <div className="col intro">
            <p>ABOUT</p>
            <p
              style={{
                width: "450px",
              }}
            >
              Magellan Restaurant, covering 470 sqm in the prestigious Next
              Level AVM, combines modern style with classic charm. Our work
              included the full design and 3D visualization, featuring a color
              scheme of deep greens, browns, and black details, complemented by
              custom furniture and hanging greenery. Key features of the space
              include modern chandeliers, a backlit bar with bold branding, and
              high-quality materials like marble and metal finishes. We worked
              closely with suppliers, supervised production, and managed the
              installation process to create a smooth and high-end dining
              experience.
            </p>
          </div>
          <div className="col portrait">
            <div className="portrait-container">
              <div className="img">
                <ParallaxImage
                  src="/Images/CommercialImages/1MagellanRestaurant/DESIGN/MasaDetay2.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>

        <section className="banner">
          <MagellanSelection />
        </section>

        <section className="banner">
          <div className="img">
            <ParallaxImage
              src="/Images/CommercialImages/1MagellanRestaurant/DESIGN/CafeYanRenderb.jpg"
              alt=""
            />
          </div>

          {/* <div className="banner-copy">
              <p
              
              >Location:</p>
              <h1
                style={{
                    color:"#1a1a1a"
                }}
              >Yenimahalle, </h1>
             <h1
               style={{
                color:"#1a1a1a"
            }}
             >Ankara-TURKIYE</h1>
            
            </div> */}
        </section>

        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                A Harmonious Blend of Modern Elegance and Timeless Charm
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
        <div>
          <h1
            style={{
              marginBottom:"20px",
              textAlign:"center",
              textTransform:"uppercase",
              fontSize:"35px",
              fontWeight:"100"
            }}
          >
          3d visualizations
          </h1>
        <MagellanShow />
        </div>

        <div>
          <h1
            style={{
              marginBottom:"20px",
              textAlign:"center",
              textTransform:"uppercase",
              fontSize:"35px",
              fontWeight:"100",
              marginTop:"50px"
            }}
          >
          completed projects
          </h1>
        <MagellanShow2 />
        </div>
      
        <CommercialSelectionComponent />
      </div>
    </ReactLenis>
  );
}
